import { faPenToSquare } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const EditButton = ({ articleSlug }: { articleSlug: string }) => {
	const articleUrl = `https://manage.${process.env.NEXT_PUBLIC_FRONT_URL}/tournaments/news-content/news/${articleSlug}`;

	return (
		<div className="top-6 z-50 flex flex-col items-start justify-center rounded-full hover:bg-gray-100" onClick={(e) => e.stopPropagation()}>
			<a href={`${articleUrl}`} className="flex w-full items-center sm:px-3 hover:cursor-pointer mr-3 sm:mr-0" aria-label="Edit Article">
				<div className="flex items-center justify-center gap-2">
					<FontAwesomeIcon icon={faPenToSquare} />
					<p className="text-gray-900 text-sm sm:text-base">Edit article</p>
				</div>
			</a>
		</div>
	);
};

export default EditButton;
